import { Container } from "../MuiGenerals";
import { customSx } from "src/utils/styling";
import TableTab from "../TableTab";
import PageConfigProvider from "src/features/PageConfigProvider";
import { GridColDef } from "@mui/x-data-grid";

function TableTemplate<TableRow>({
  columns,
  rows,
}: {
  columns: GridColDef<any, any, any>[];
  rows: TableRow[];
}) {
  return (
    <Container
      style={customSx.datagridContainer}
      maxWidth={false}
      disableGutters
    >
      <TableTab>
        <PageConfigProvider.DataGrid columns={columns} rows={rows} />
      </TableTab>
    </Container>
  );
}

export default TableTemplate;
